module.exports = __webpack_public_path__ + "static/media/INZ1027.4e80d0b7.pdf";